var GrouponGsm;

GrouponGsm = {};

if (typeof Finch !== "undefined" && Finch !== null) {
  GrouponGsm.query_string = function() {
    return window.location.search;
  };
  GrouponGsm.request_from_certain_channel = function(channel) {
    var regex;
    regex = new RegExp(["[?&]utm_campaign=US_\\w{2}_", channel, "_"].join(""), "i");
    return regex.test(this.query_string());
  };
  GrouponGsm.explicitly_skip_modal = function() {
    return /[?&]sm=0/i.test(this.query_string());
  };
  GrouponGsm.user_has_sub_cookie = function() {
    var cookiePresent, sub_cookies;
    sub_cookies = ["subscriber_email", "scid", "l", "user_id"];
    cookiePresent = false;
    $.each(sub_cookies, function(index, value) {
      if (Cookie.get('value')) {
        cookiePresent = true;
        return false;
      }
    });
    return cookiePresent;
  };
  GrouponGsm.user_has_hide_sub_cookie = function() {
    return Cookie.get("hide_sub_banner") || Cookie.get("hide_sub_modal");
  };
  Finch.Experiments.Global.guards = {
    on_gsm_platform_page: function() {
      return true;
    },
    request_from_display_ads: function() {
      return GrouponGsm.request_from_certain_channel('DPN');
    },
    request_not_from_display_ads: function() {
      return !GrouponGsm.request_from_certain_channel('DPN');
    },
    request_from_sem_ads: function() {
      return GrouponGsm.request_from_certain_channel('SEA');
    },
    request_from_normal_seo: function() {
      return !GrouponGsm.request_from_certain_channel('DPN' && !GrouponGsm.request_from_certain_channel('SEA'));
    },
    user_has_no_sub_cookie: function() {
      return !GrouponGsm.user_has_sub_cookie();
    },
    user_has_no_hide_sub_cookie: function() {
      return !GrouponGsm.user_has_hide_sub_cookie();
    },
    not_explicitly_skip_modal: function() {
      return !GrouponGsm.explicitly_skip_modal();
    }
  };
  if (Finch.TrackingHubTracker == null) {
    Finch.TrackingHubTracker = {
      track: function(experimentSets) {
        return _(experimentSets).each(function(experimentSet) {
          var error, experimentId, layerName, variantName;
          layerName = experimentSet.layer.name;
          experimentId = experimentSet.experiment.id;
          variantName = experimentSet.variant;
          error = experimentSet.error;
          return OptimizeSuite.TrackingHub.add("finch-experiment", {
            layer: layerName,
            experiment: experimentId,
            variant: variantName,
            error: error
          });
        });
      }
    };
  }
}

//# sourceMappingURL=data:application/json;base64,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
